import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { STORAGE_KEYS } from "@/infrastructure/storage/constants";

const isBrowser = typeof window !== "undefined";

interface HubProfileUIState {
	selectedProfileUuid: string | null;
	isSwitchingProfile: boolean;
	setSelectedProfile: (uuid: string | null) => void;
	setIsSwitchingProfile: (switching: boolean) => void;
	clearSwitchingState: () => void;
	reset: () => void;
}

export const useHubProfileStore = create<HubProfileUIState>()(
	devtools(
		(set) => ({
			selectedProfileUuid: (() => {
				if (!isBrowser) return null;
				try {
					return localStorage.getItem(STORAGE_KEYS.HUB_SELECTED_PROFILE);
				} catch {
					return null;
				}
			})(),
			isSwitchingProfile: false,
			setSelectedProfile: (uuid) => set({ selectedProfileUuid: uuid }),
			setIsSwitchingProfile: (switching) =>
				set({ isSwitchingProfile: switching }),
			clearSwitchingState: () => set({ isSwitchingProfile: false }),
			reset: () =>
				set({ selectedProfileUuid: null, isSwitchingProfile: false }),
		}),
		{ name: "HubProfileStore" },
	),
);
